import styled from 'styled-components'

// Styled components
export const ResultsTable = styled.table`
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    border-spacing: 0;

    th {
        border: 1px solid rgb(220,220,220);
        font-weight: 300;
        padding: 0.5rem;
    }

    tr {
        background: white;
    }

    td {
        font-size: 0.9rem;
        padding: 0.5rem;
        border-style: solid;
        border-width: 0.01em;
        border-color: rgb(220,220,220);
    }

    @media (max-width: 600px) {
        
        th {
            font-size: 0.8rem;
        }

        td {
            word-break: break-all;
            font-size: 0.7rem;
            padding: 0;
            padding-left: 5px;
        }
        
    }
`



